import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, requireSurvey = false, requireAdmin = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-white">
        <Loader2 className="w-8 h-8 animate-spin text-brand-red" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !["admin", "sub_admin", "super_admin"].includes(user.role)) return <Navigate to="/" replace />;
  if (requireSurvey && !user.survey_completed) return <Navigate to="/survey" replace />;
  return children;
};
